import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

// 알림 목록에서 항목 하나를 확인 처리한다. (확인한 주문건만 상태변경 이력에 남는다)
export const usePutAlertRead = () => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (alert_idx: number) => {
            const response = await axios.put(
                enum_api_uri.put_alert_read.replace(":alert_idx", String(alert_idx)),
                {},
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                },
            );
            return response.data;
        },
        onSuccess: () => {
            // 확인한 주문의 상태변경 내역과 담당자 표기가 바뀌므로 함께 다시 받는다
            queryClient.invalidateQueries({ queryKey: ["getOrderHistory"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderInfo"] });
        },
    });
};
